import { pickBy } from "lodash";

import {
  EmployeeCandidateRequestFilter,
  StringFilterMode,
} from "../../graphql/generated.ts";
import { FiltersValue } from "./types.ts";

export const getEmployeeCandidateFilter = (
  value: FiltersValue
): EmployeeCandidateRequestFilter => {
  return pickBy({
    candidateName: value.candidateName && {
      contains: value.candidateName,
      mode: StringFilterMode.Insensitive,
    },
    clikResultCategory: value.clikResultCategory?.length && {
      in: value.clikResultCategory,
    },
    hiringStatus: value.hiringStatus?.length && { in: value.hiringStatus },
  });
};
